import { Injectable } from '@angular/core';
import { CountryCode } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class VATDisclaimerService {
  constructor() {}

  //This list is taken from configCat conditions for this feature to be true
  VATDisclaimerEnabledCountriesList = [
    CountryCode.Spain,
    CountryCode.Italy,
    CountryCode.Netherlands,
    CountryCode.Portugal
  ];

  getVATDisclaimerForCountry(countryCode: CountryCode): boolean {
    return this.VATDisclaimerEnabledCountriesList.includes(countryCode);
  }
}
